/**
 * El copy de «Tu bot está listo» (GKTIBO-126).
 *
 * Vive aparte porque `textos.ts` pasaba las 300 líneas (D4), y porque separa
 * bien: esto es lo que se lee al terminar el alta, y se toca cuando se ajusta
 * ese momento y no ningún otro.
 */

/**
 * El cierre del alta (GKTIBO-126).
 *
 * Dice dos cosas a la vez y las dos son ciertas: tu bot ya sabe atender, y
 * todavía nadie puede escribirle. Celebrar sin lo segundo sería festejar
 * algo que el dueño no puede usar.
 */
export const listo = {
  titulo: 'Tu bot está listo',
  bajada:
    'Sabe lo que hace tu negocio y ya lo probaste. De acá en adelante podés seguir mejorándolo cuando quieras.',
  tituloEnVivo: 'Tu bot está en vivo',
  bajadaEnVivo: 'Desde ahora contesta solo. Lo vas a ver en Conversaciones.',

  nadiePuedeEscribirle: 'Todavía nadie puede escribirle',
  faltaCanal:
    'Falta conectar un canal —WhatsApp o Telegram—. Son unos minutos y lo podés hacer ahora o cuando tengas los datos a mano.',
  conectarAhora: 'Conectar un canal',
  masTarde: 'Más tarde',

  activar: 'Poner mi bot en vivo',
  noSePudoActivar: 'No pudimos poner tu bot en vivo. Probá de nuevo en un momento.',
  irAlPanel: 'Ir a mi panel',
} as const;
